export default {
  en: {
    title: 'Chats',
    actions: { mark_all_as_read: 'Mark all as read' },
  },
};
